import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: () => import('@/pages/payment/PaymentPage.vue'),
        },
        {
            path: '/giveaway',
            component: () => import('@/pages/giveaway/GiveawayPage.vue'),
        },
        {
            path: '/giveaway-history',
            component: () => import('@/pages/giveaway/GiveawayHistoryPage.vue'),
        },
        {
            path: '/wait',
            component: () => import('@/pages/wait/WaitPage.vue'),
        },
        {
            path: '/sbp-wait',
            component: () => import('@/pages/payment/SBPWaitPage.vue'),
        },
        {
            path: '/card-sberpay-wait',
            component: () => import('@/pages/payment/CardSberPayWaitPage.vue'),
        },
        {
            path: '/support',
            component: () => import('@/pages/support/SupportPage.vue'),
        },
        {
            path: '/faq',
            component: () => import('@/pages/faq/FaqPage.vue'),
        },
        {
            path: '/terms',
            component: () => import('@/pages/terms/TermsPage.vue'),
        },
        {
            path: '/contacts',
            component: () => import('@/pages/contacts/ContactsPage.vue'),
        },
        {
            path: '/comms',
            component: () => import('@/pages/comms/CommsPage.vue'),
        },
        {
            path: '/ps-store',
            component: () => import('@/pages/psstore/PSStorePage.vue'),
        },
        {
            path: '/mobile-games',
            component: () => import('@/pages/mobilegames/MobileGamesPage.vue'),
        },
        {
            path: '/steam-gift',
            component: () => import('@/pages/steamgift/SteamGiftPage.vue'),
        },
    ]
})

export default router